import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { LogIn } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Bem-vindo(a) de volta!");
      const target = res.user?.role === "admin" ? "/admin" : (location.state?.from || "/timeline");
      navigate(target, { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="container-cuidar py-16 md:py-24 grid lg:grid-cols-2 gap-12 items-center">
      <div className="hidden lg:block">
        <div className="text-xs font-semibold tracking-widest uppercase text-[hsl(var(--secondary))]">Boas-vindas</div>
        <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-black leading-[1.05]">Entrar no <span className="text-[hsl(var(--primary))]">Instituto Cuidar</span></h1>
        <p className="mt-5 max-w-md text-[hsl(var(--muted-foreground))]">
          Acesse conteúdos exclusivos, salve postagens e participe da nossa comunidade acolhedora.
        </p>
      </div>
      <div className="mx-auto w-full max-w-md">
        <div className="surface p-7 sm:p-8">
          <div className="mb-6 flex flex-col items-start gap-4">
            <img src="/logo-instituto-cuidar.png" alt="Instituto Cuidar" className="h-12 w-auto object-contain" />
            <div>
              <h2 className="font-heading text-2xl font-extrabold">Entrar</h2>
              <p className="text-sm text-[hsl(var(--muted-foreground))]">Bem-vindo(a) de volta.</p>
            </div>
          </div>
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">E-mail</Label>
              <Input id="email" type="email" required autoComplete="email" data-testid="login-email-input"
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 h-12 rounded-xl" />
            </div>
            <div>
              <Label htmlFor="password">Senha</Label>
              <Input id="password" type="password" required autoComplete="current-password" data-testid="login-password-input"
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 h-12 rounded-xl" />
              <div className="mt-2 text-right">
                <Link to="/esqueci-senha" className="text-xs text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--primary))] hover:underline" data-testid="login-forgot-password-link">
                  Esqueci minha senha
                </Link>
              </div>
            </div>
            <Button
              type="submit" disabled={loading} data-testid="login-submit-btn"
              className="btn-pill w-full h-12 bg-[hsl(var(--primary))] text-white hover:bg-[hsl(var(--primary))]/90"
            >
              {loading ? "Entrando…" : "Entrar"}
            </Button>
          </form>
          <div className="mt-6 text-sm text-[hsl(var(--muted-foreground))]">
            Ainda não tem conta?{" "}
            <Link to="/cadastro" className="link-underline text-[hsl(var(--primary))] font-medium" data-testid="login-goto-register">Cadastrar</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
